import {
  DeckBattleResumePayload,
  DeckBattleStartedPayload,
} from "@/types/battle"

export function deckResumeToStarted(
  resume: DeckBattleResumePayload
): DeckBattleStartedPayload {
  return {
    battleId: resume.battleId,
    mode: resume.mode,
    deckSearchMode: resume.deckSearchMode,
    colorRank: resume.colorRank,
    you: resume.you,
    opponent: resume.opponent,
    yourDeck: resume.yourRemainingDeck.length
      ? resume.yourRemainingDeck
      : resume.yourDeck,
    phase: resume.phase,
    currentRound: resume.currentRound,
    yourRoundWins: resume.yourRoundWins,
    opponentRoundWins: resume.opponentRoundWins,
    roundsToWin: resume.roundsToWin,
    playCardTimeoutSec: resume.playCardTimeoutSec,
  }
}
